export const fullscreenFixedOptions = {
  allowDownload: false,
  allowSocial: false,
  loveButton: false,
  isStoreGallery: false,
  loveCounter: true,
  allowTitle: true,
  allowExifExpand: false,
  addToCartButtonText: '',
  galleryAlignExpand: 'left',
  mobileSwipeAnimation: 'EXPAND',
  enableFullscreenVideoPlaceholder: true,
  allowBackgroundGradient: false,
  backgroundGradientDegrees: 180,
  stylingParams_itemResolutionMode: 'SCALED_DOWN',
  layoutParams_navigationArrows_position: 'MOUSE_CURSOR'
};
//# sourceMappingURL=fullscreenFixedStyles.js.map